import {isNil} from 'ramda';

import {FinancingStatusResponseBodySaleVehiclePhoto} from '@dms/api/vehicle';

import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';

// Only own promo photos carry the catalog `promotionalPhotoId`; a READY financing status for that
// catalog item marks the rendered card in the gallery.
export const isFinancingPromoPhoto = (
  image: Pick<UnifiedAlbumImage, 'isPromoPhoto' | 'promotionalPhotoId'>,
  financingStatus: FinancingStatusResponseBodySaleVehiclePhoto[] | undefined
) => {
  if (!image.isPromoPhoto || isNil(image.promotionalPhotoId)) {
    return false;
  }

  return (financingStatus ?? []).some(
    (entry) => entry.status === 'READY' && entry.promotionalPhotoId === image.promotionalPhotoId
  );
};
